import { PROFILE_TAB_MODULE_ID } from '../components/layout/navigationModules';
import { usePageTabConfig } from './usePageTabConfig';

/**
 * Profile-page tab visibility for the current user's company.
 * Thin alias over the generic {@link usePageTabConfig}; the "personal" tab is
 * pinned on via `alwaysEnabled` in the tab registry.
 */
export function useProfileTabConfig() {
  return usePageTabConfig(PROFILE_TAB_MODULE_ID);
}
